var exports = {};
var a = Symbol.for("react.fragment");
exports.Fragment = a;
exports.jsxDEV = void 0;
export default exports;